<template>
  <!-- <el-drawer
    :visible="visible" :modal="false" direction="btt" :withHeader="false"
    size="100%" :close-on-press-escape="false" custom-class="no-animation"> -->
  <div v-loading="dataLoading">
    <rhcn-drawer
      :title="titleText"
      :description="$t('message.collection.vaFormTitleTips')"
      @on-close="handleClose">
      <div v-if="!showResult" class="virtual-modal-wrapper">
        <div v-if="errorMessage" class="fail-reason-box" :class="{'expand': showErrorDetails}" @click="handleErrorReason">
          <p>{{$t('message.collection.errorTitle')}}</p>
          <p v-show="showErrorDetails">{{errorMessage}}</p>
          <i class="el-icon-arrow el-icon-arrow-up" :class="{'is-reverse': showErrorDetails}"></i>
        </div>
        <div class="form-wrapper">
          <validation-component
            ref="appForm"
            :validation-condition="virtualAccountCondition"
          >
            <template slot="name">
              <div class="name-list">
                <div v-for="(item, index) in nameList" :key="index" class="name-list-item">
                  <el-input
                    v-model="nameList[index].firstName"
                    class="name-input"
                    maxlength="35"
                    :placeholder="$t('message.tableCommon.firstName')"
                    @input="handleNameChange(index, 'firstName', $event)"></el-input>
                  <el-input
                    v-model="nameList[index].lastName"
                    class="name-input margin-left-10"
                    maxlength="35"
                    :placeholder="$t('message.tableCommon.lastName')"
                    @input="handleNameChange(index, 'lastName', $event)"></el-input>
                  <i v-if="nameList.length > 1" class="el-icon-remove-outline" @click="handleRemoveName(index)"></i>
                  <i v-if="nameList.length < 4 && index === (nameList.length - 1)" class="el-icon-circle-plus-outline" @click="handleAddName"></i>
                </div>
              </div>
            </template>
            <template slot="address">
              <multi-line-input
                :data="addressList"
                :placeholder="addressPlaceholder"
              ></multi-line-input>
            </template>
            <template slot="websiteParam">
              <template v-if="websiteComponentMap[websiteType]">
                <component ref="appContentForm" :info="extraData" :is="websiteComponentMap[websiteType]"></component>
              </template>
            </template>
          </validation-component>
          <div class="margin-top-40 margin-bottom-25">
            <el-button
              style="width: 100%"
              type="primary"
              :loading="requesting"
              @click="onSubmit"
              >{{ $t("message.common.submit") }}</el-button
            >
          </div>
        </div>
      </div>
      <template v-if="showResult" #title>
        <div class="virtual-success-top">
          <div class="top-title-box">
            <img class="top-title-icon" :src="require(`@/assets/images/currency/${account.bizCurrency}.png`)" />
            <span>{{account.bizCurrency}}</span>
          </div>
          <p class="title-tips">{{$t('message.collection.createVaSuccessTips')}}</p>
        </div>
      </template>
      <div v-if="showResult" class="virtual-modal-wrapper">
        <div class="form-wrapper success-form-wrapper">
          <div class="account-info">
            <div class="account-info-box">
              <p class="account-info-name">{{account.holderName}}</p>
              <p class="account-info-desc">{{account.bizCurrency}}</p>
            </div>
            <el-tag type="disabled" class="account-info-label">{{account.accountLabel}}</el-tag>
            <el-tag type="success">{{account.vaStatusText}}</el-tag>
          </div>
          <el-form label-position="top">
            <el-form-item v-for="(item, index) in accountInfo" :key="index" :label="item.isInternationalization ? $t(item.label) : item.label">
              <div class="va-form-item">
                <span>{{item.value}}</span>
                <span class="icon-copy-box" @click="handleCopy(item.value)"><i class="iconfont icon-copy"></i></span>
              </div>
            </el-form-item>
            <el-form-item v-if="tipsList.length > 0" :label="$t('message.collection.accountFunction')">
              <div class="account-func">
                <div v-for="(item, index) in tipsList" :key="index" class="account-func-item">
                  <div class="account-func-item-title">
                    <i class="item-icon el-icon-circle-check"></i>
                    <span>{{item.functionTips}}</span>
                  </div>
                  <div class="account-func-item-desc">{{item.timeTips}}</div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="margin-top-40 margin-bottom-25">
          <el-button
            style="width: 100%"
            type="primary"
            @click="handleClose"
            >{{ $t("message.common.confirm") }}</el-button
          >
        </div>
      </div>
    </rhcn-drawer>
  </div>
  <!-- </el-drawer> -->
</template>

<script>
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import MultiLineInput from '@/components/form/multi-line-input.vue';
import { ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips.js';
import { REQUIRED, OTHER_WORD } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import ApplicationService from '@/views/application/api/application-list.service.js';
import { ACCOUNT_TYPE_OPTIONS } from '@/views/collection/api/options.js';
import { addVAInfo, updateUserVAInfo } from '@/views/collection/api/va.js';
import AliexpressInfo from '@/views/collection/virtual-account/add/aliexpress-info.vue';
import AmazonEUInfo from '@/views/collection/virtual-account/add/amazon-eu-info.vue';
import AmazonJPInfo from '@/views/collection/virtual-account/add/amazon-jp-info.vue';
import AmazonUSInfo from '@/views/collection/virtual-account/add/amazon-us-info.vue';
import EbayInfo from '@/views/collection/virtual-account/add/ebay-info.vue';
import ShopifyInfo from '@/views/collection/virtual-account/add/shopify-info.vue';

export default {
  components: {
    RhcnDrawer,
    ValidationComponent,
    MultiLineInput,
    AliexpressInfo,
    EbayInfo,
    ShopifyInfo,
    AmazonUSInfo,
    AmazonEUInfo,
    AmazonJPInfo,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataLoading: false,
      requesting: false,
      showResult: false,
      virtualAccountCondition: [{
        key: 'accountCountry',
        name: 'message.collection.selectCountry',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.select', { select: '' }),
        rule: [REQUIRED],
        option: {
          label: 'description',
          value: 'value',
        },
      }, {
        key: 'websiteType',
        name: 'message.application.appType',
        type: 'select',
        isShowStar: true,
        placeholder: this.$t('message.validator.select', { select: '' }),
        rule: [REQUIRED],
        isHide: true,
        options: [],
        option: {
          label: 'description',
          value: 'value',
        },
        changeValue: (value) => {
          this.websiteType = value;
          const hideWebsiteParam = !this.websiteComponentMap[value];
          this.$refs.appForm.setItemHide('websiteParam', hideWebsiteParam);
          // 清空并重置币种选项
          this.$refs.appForm.setItemValue('applyCurrency', '');
          this.setCurrencyOptions(this.websiteType);
        },
      }, {
        key: 'websiteParam',
        name: '',
        type: 'slot',
        isShowStar: true,
        isHide: true,
      }, {
        key: 'applyCurrency',
        name: 'message.tableCommon.currency',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.select', { select: '' }),
        rule: [REQUIRED],
        withIcon: true,
      }, {
        key: 'bizType',
        name: 'message.collection.bizType',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.select', { select: '' }),
        rule: [REQUIRED],
        isDisabled: true,
        option: {
          label: 'description',
          value: 'value',
        },
      }, {
        key: 'accountType',
        name: 'message.collection.entityType',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.select', { select: '' }),
        rule: [REQUIRED],
        isInternationalization: true,
        options: ACCOUNT_TYPE_OPTIONS,
        isDisabled: true,
      }, {
        key: 'holderName',
        name: 'message.collection.accountHolderName',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { input: '' }),
        rule: [REQUIRED, OTHER_WORD],
      }, {
        key: 'name',
        name: 'message.collection.name',
        type: 'slot',
        isShowStar: true,
      }, {
        key: 'address',
        name: 'message.collection.address',
        type: 'slot',
        isShowStar: true,
      }],
      tipsList: [],
      accountInfo: [],
      account: {},
      statusList: [],
      currencyList: [],
      nameList: [
        { firstName: '', lastName: '' },
      ],
      addressList: ['', '', ''],
      addressPlaceholder: [
        this.$t('message.validator.input', { input: this.$t('message.collection.street') }),
        this.$t('message.validator.input', { input: this.$t('message.collection.city') }),
        this.$t('message.validator.input', { input: this.$t('message.collection.country') }),
      ],
      websiteType: '',
      websiteComponentMap: {
        WEB14: 'AliexpressInfo', // 速卖通（AliExpress
        WEB15: 'EbayInfo', // Ebay
        WEB01: 'ShopifyInfo', // 其他-自建站
        WEB02: 'ShopifyInfo', // Shopify
        WEB03: 'ShopifyInfo', // Shoplazza
        WEB08: 'ShopifyInfo', // shopline
        WEB16: 'AmazonEUInfo', // Amazon-欧洲
        WEB17: 'AmazonUSInfo', // Amazon-北美
        WEB18: 'AmazonJPInfo', // Amazon-日本
      },
      websiteTypeCurrencyMap: { // 网站限制币种
        WEB16: ['EUR', 'GBP'], // Amazon-欧洲
        WEB17: ['USD'], // Amazon-北美
        WEB18: ['JPY'], // Amazon-日本
      },
      titleText: this.$t('message.collection.createVirtualAccount'),
      showErrorDetails: false,
      errorMessage: '',
      appId: '',
      merchantNo: '',
      extraData: {},
      b2bAppInfoId: '',
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  mounted() {
    if (`${this.app.userLogin.businessType}` === '0') {
      this.titleText = 'message.collection.createVirtualAccount1';
    }
    this.initData();
  },
  methods: {
    async initData() {
      this.dataLoading = true;
      try {
        const dict = await GlobalData.getDictList(['COUNTRY', 'VA_BIZ_TYPE', 'VA_BIZ_CURRENCY', 'VA_STATUS', 'WEB_TYPE']);
        this.$refs.appForm.setValidationSelectOptions('accountCountry', dict.COUNTRY);
        this.$refs.appForm.setValidationSelectOptions('bizType', dict.VA_BIZ_TYPE);
        // 筛选特定的网站类型
        const websiteTypeList = dict.WEB_TYPE.filter(item => this.websiteComponentMap[item.value]);
        this.$refs.appForm.setValidationSelectOptions('websiteType', websiteTypeList);

        this.statusList = initSelectedData(dict.VA_STATUS);
        this.currencyList = dict.VA_BIZ_CURRENCY.map(item => ({
          icon: require(`@/assets/images/currency/${item.value}.png`),
          label: item.value,
          value: item.value,
        }));
        // applyCurrency
        this.$refs.appForm.setValidationSelectOptions('applyCurrency', this.currencyList);

        const userInfo = this.app.userLogin;
        let bizType = '';
        if (`${userInfo.businessType}` === '2') { // B2C
          bizType = 'B2C';
          this.$refs.appForm.setItemHide('websiteType', false); // 显示网站类型
        } else if (`${userInfo.businessType}` === '0') {
          bizType = 'B2B';
        }
        let accountType = 'C';
        if (`${userInfo.type}` === '2') { // 主体类型为 个人 // （企业类型，1：企业  2：个人 3：测试）
          accountType = 'P';
          this.$refs.appForm.setItemHide('name', true); // 隐藏股东信息
          this.$refs.appForm.setItemHide('address', true); // 隐藏地址信息
        }
        this.$refs.appForm.setItemValue('bizType', bizType);
        this.$refs.appForm.setItemValue('accountType', accountType);

        const appId = this.$route.query.appId;
        if (appId) { // 存在 appId, 代表编辑
          this.appId = appId;
          this.titleText = `${userInfo.businessType}` === '0' ? this.$t('message.collection.editVirtualAccount1') : this.$t('message.collection.editVirtualAccount');
          const res = await ApplicationService.getApplicationDetails({ id: appId });
          this.merchantNo = res.merchantNo;
          this.b2bAppInfoId = res.b2bAppInfoId;
          if (res.externalMsg) {
            this.extraData = JSON.parse(res.externalMsg);
            this.extraData.appName = res.appName;
          }
          this.websiteType = res.websiteType;
          this.errorMessage = res.auditComments;
          this.addressList = [res.street || '', res.city || '', res.country || ''];
          if (res.name) {
            this.nameList = JSON.parse(res.name);
          }
          if (this.websiteComponentMap[res.websiteType]) {
            this.$refs.appForm.setItemHide('websiteParam', false); // 显示
          }
          this.setCurrencyOptions(this.websiteType);
          this.$refs.appForm.setItemValue('websiteType', res.websiteType);
          this.$refs.appForm.setItemValue('holderName', res.accountHolderName);
          this.$refs.appForm.setItemValue('accountCountry', res.accountCountry);
          this.$refs.appForm.setItemValue('applyCurrency', res.applyCurrency);

          this.$refs.appForm.setItemDisabled('websiteType', true);
          this.$refs.appForm.setItemDisabled('accountCountry', true);
          this.$refs.appForm.setItemDisabled('applyCurrency', true);
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    handleClose() {
      // this.requesting = false;
      // if (this.$refs.appForm) {
      //   this.$refs.appForm.formReset();
      // }
      // this.nameList = [{ firstName: '', lastName: '' }];
      // this.addressList = ['', '', ''];
      // this.$emit('close');
      // // 判断是否创建 VA, 已成功创建 VA, 则调用刷新
      // if (this.showResult) {
      //   this.$emit('refresh');
      // }
      // this.showResult = false;

      this.$router.go(-1);
    },
    scrollError() {
      this.$nextTick(() => {
        const errorDom = document.querySelector('.is-error');
        if (errorDom) {
          errorDom.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
          });
        }
      });
    },
    onSubmit() {
      this.$refs.appForm.toFormValid(async (params) => {
        const websiteParam = {};
        if (params.accountType !== 'P') { // 主体类型不是 个人 时，需要股东、地址信息
          for (let i = 0; i < this.nameList.length; i++) {
            const name = this.nameList[i];
            if (!name.firstName || !name.lastName) {
              ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.collection.name') }));
              return;
            }
          }
          for (let i = 0; i < this.addressList.length; i++) {
            if (!this.addressList[i]) {
              ShowWarningMessage(this.addressPlaceholder[i]);
              return;
            }
          }

          websiteParam.name = JSON.stringify(this.nameList);
          websiteParam.street = this.addressList[0] || '';
          websiteParam.city = this.addressList[1] || '';
          websiteParam.country = this.addressList[2] || '';
        }

        if (this.$refs.appContentForm) {
          try {
            const res = await this.$refs.appContentForm.getParams();
            Object.assign(websiteParam, res);
          } catch (err) {
            this.scrollError();
            throw err;
          }
        }

        if (params.bizType === 'B2B') { // B2B 时，网站类型为 VA （暂时写死）
          params.websiteType = 'WEB13';
        }

        this.requesting = true;
        try {
          const data = {
            ...params,
            websiteParam: JSON.stringify(websiteParam),
          };
          let MethodSub = addVAInfo;
          if (this.appId) {
            data.appId = this.appId;
            data.merchantNo = this.merchantNo;
            data.b2bAppInfoId = this.b2bAppInfoId;
            MethodSub = updateUserVAInfo;
          }
          const res = await MethodSub(data);
          if (this.appId) { // 如果是重新修改，则完成后直接返回
            this.handleClose();
            return;
          }
          this.account = {
            holderName: res.holderName,
            bizCurrency: res.bizCurrency,
            accountLabel: res.accountLabel,
            vaStatus: res.vaStatus,
            vaStatusText: getEnantiomericValue(this.statusList, res.vaStatus),
          };
          this.tipsList = res.tipList || [];
          this.accountInfo = res.infoList || [];
          this.showResult = true;
        } catch (err) {
          if (err.respCode === '00004|00021|cl0068') { // 申请已受理，请联系客户经理分配账号
            this.handleClose();
            // this.$emit('refresh');
          }
        }
        this.requesting = false;
      }, () => {
        this.scrollError();
      });
    },
    async handleCopy(data) {
      await this.$copyText(data);
      ShowSuccessMessage(this.$t('message.common.copySuccess'));
    },
    handleAddName() {
      this.nameList.push({ firstName: '', lastName: '' });
    },
    handleRemoveName(index) {
      this.nameList.splice(index, 1);
    },
    handleNameChange(index, key, value) {
      this.nameList[index][`${key}`] = value.replace(/[^a-zA-Z]/g, '').toLocaleUpperCase();
    },
    handleErrorReason() {
      this.showErrorDetails = !this.showErrorDetails;
    },
    setCurrencyOptions(websiteType) {
      let list = this.currencyList;
      if (websiteType && this.websiteTypeCurrencyMap[websiteType]) {
        const limitList = this.websiteTypeCurrencyMap[websiteType];
        list = this.currencyList.filter(item => (limitList.indexOf(item.value) > -1));
      }
      this.$refs.appForm.setValidationSelectOptions('applyCurrency', list);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.virtual-modal-wrapper {
  width: 500px;
  margin: 0 auto;
  .form-wrapper {
    width: 450px;
    margin: 23px auto 0;

    &.success-form-wrapper {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
      border-radius: 2px;
      padding: 25px;
      margin-top: 20px;

      .va-form-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: Avenir-Book, Avenir;
        font-weight: normal;
        color: $color-text-primary;
        line-height: 32px;

        .icon-copy-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 33px;
          height: 33px;
          border-radius: 4px;
          font-size: 20px;
          font-weight: 800;
          color: $color-success;
          cursor: pointer;

          &:hover {
            background: #F1F5F7;
          }
        }
      }
    }

    .name-list {
      .name-list-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

        .name-input {
          width: 180px;
        }

        .el-icon-remove-outline, .el-icon-circle-plus-outline {
          font-size: 27px;
          color: $color-primary;
          margin-left: 12px;
          cursor: pointer;
        }
      }
    }
  }

  .fail-reason-box {
    position: relative;
    width: 450px;
    height: 30px;
    background: #FFF2F2;
    margin: 0 auto;
    margin-top: 20px;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-text-primary;
    line-height: 32px;
    padding-left: 10px;
    padding-right: 30px;
    box-sizing: border-box;
    white-space: pre-line;

    &.expand {
      height: auto;
      padding-bottom: 10px;

      .el-icon-arrow {
        transform: rotateX(180deg);
      }
    }

    .el-icon-arrow {
      position: absolute;
      right: 10px;
      top: 10px;
      transition: all 0.2s;
    }
  }
}

.account-info {
  display: flex;
  position: relative;
  color: $color-text-primary;
  border-bottom: 1px solid rgba(0,32,63,0.08);
  padding-bottom: 10px;
  margin-bottom: 20px;
  align-items: center;

  .account-info-box {
    flex: 1;
  }

  .account-info-name {
    font-size: 16px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
  }

  .account-info-desc {
    font-size: 14px;
    font-weight: 400;
    line-height: 32px;
  }

  .account-info-label {
    margin-right: 20px;
  }

  .account-info-status {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}

.account-func {
  background: #F1F5F7;
  border-radius: 2px;
  padding: 10px;

  .account-func-item {
    margin-bottom: 5px;
    .account-func-item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: $color-text-primary;
      line-height: 32px;

      .item-icon {
        // width: 17px;
        // height: 17px;
        font-size: 17px;
        margin-right: 10px;
        font-weight: 800;
        color: $color-success;
      }
    }

    .account-func-item-desc {
      margin-left: 27px;
      font-size: 14px;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 18px;
    }
  }
}
</style>
<style lang="scss">
@import '@/styles/variables.scss';

.virtual-success-top {
  width: 450px;
  margin: 18px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .top-title-box {
    display: flex;
    align-items: center;
    font-size: 26px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: #264373;
    line-height: 36px;

    .top-title-icon {
      width: 30px;
      height: 30px;
      margin-right: 20px;
    }
  }

  .title-tips {
    font-size: 16px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 22px;
  }
}

html[lang=en] .virtual-modal-wrapper .fail-reason-box {
  width: 520px !important;
}
</style>
